import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function SupportFab() {
  const { t } = useTranslation('common');

  return (
    <Link to="/support" className="support-fab" aria-label={t('footerSupport')}>
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M4 12a8 8 0 0116 0v2.5a2.5 2.5 0 01-2.5 2.5H16a2 2 0 01-2-2v-2a2 2 0 012-2h1.1M4 12.5V14a2 2 0 002 2h.9"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <path d="M9 19h6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    </Link>
  );
}
